import * as Material from "@mui/material";
import React from "react";
import axios from "axios";
import moment from "moment";
import {Checkbox, Chip, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, FormControl, Box, Autocomplete, TextField, Button} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function Form_UserSelect(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;
    const { disabled = false } = item;
    const height = inputSize === "normal" ? 56 : 43;

    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selected, setSelected] = React.useState([]);

    const [crews, setCrews] = React.useState([]);
    const getCrews = async () => {
        try {
            const response = await axios.get("/shared/users");
            setCrews(response.data);
            let groups = {};
            response.data.forEach((user) => {
                // TODO: to change to handle multiple groups.

                user.groups.forEach((group) => {
                    if (groups[group.group.Name] === undefined) groups[group.group.Name] = [];
                    groups[group.group.Name].push(user);
                })

                // if (groups[user.group] === undefined) groups[user.group] = [];
                // groups[user.group].push(user);
            })
            let groupList = Object.keys(groups).map((g_key) => {

                return {
                    id: g_key,
                    name: g_key,
                    type: 'group',
                    users: groups[g_key]
                }
            }).filter((g) => g.name !== "null");

            let list = [...response.data.map((user) => {
                    return { name: user.full_name, type: 'user', id: user.id, users: [user] };
                }),
                ...groupList
            ];
            setCrewGroups(groups);

            setSelectOptions(list)
        } catch (err) {
            console.log(err);
        }
    };
    React.useEffect(() => getCrews().then(), []);

    const [crewGroups, setCrewGroups] = React.useState([]);

    function handleChange(event) {
        const {
            target: { value },
        } = event;
        // alert(JSON.stringify(value));
        setSelected(value);
        // setSelected(s => [...s, selectOptions[value]]);
    }


    React.useEffect(() => {
        let value = [];
        selected.forEach((selectedIndex) => {
            let i = selectOptions[selectedIndex];
            value.push(...i.users);
        })
        setLocalFormState({
            ...localFormState,
            [item.key]: [...new Set([...value])]
        });
    }, [selected]);

    React.useEffect(() => {
        // localFormState[item.key]
        if (localFormState === undefined) return;
        if (localFormState[item.key] === undefined) return; // here check is value is a list of objects vs list of strings?!
        if (Array.isArray(localFormState[item.key])) return;
        let nameList = localFormState[item.key].split(',');
        let selectedList = nameList.map((name) => {
            let ops = selectOptions.filter((o) => o.name === name);
            console.log(ops)
            console.log(name);
            console.log(selectOptions);
            console.log(selectOptions);

            if (ops.length > 0){
                return selectOptions.indexOf(ops[0]);
            }
            return null;
        });
        console.log(selectedList)
        console.log(selected);
        setSelected(selectedList.filter(v => v !== null));
    }, [localFormState]);

    return (<>
        {/*<pre style={{height : '500px', overflow: 'scroll'}}>{JSON.stringify(localFormState[item.key], undefined, 4)}</pre>*/}
        {/*<pre style={{height : '500px', overflow: 'scroll'}}>{JSON.stringify(selectOptions, undefined, 4)}</pre>*/}
        {/*<pre>{JSON.stringify(selected)}</pre>*/}
        <FormControl sx={{ width: '100%' }} required={ item.required || false }>
            <InputLabel id="demo-multiple-checkbox-label">Crew</InputLabel>
            <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                fullWidth={true}
                value={selected}
                onChange={(event) => handleChange(event)}
                input={<OutlinedInput fullWidth={true} label="Crew" />}
                // renderValue={(selected) => selected.map(s => selectOptions[s].name).join(', ')}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip variant="filled" color={'info'} key={value} label={selectOptions[value].name} />
                        ))}
                    </Box>
                )}
                // renderTags={(value, getTagProps) =>
                //     value.map((option, index) => (
                //         <Chip variant="filled" sx={{ color: 'black' }} color={'info'} label={selectOptions[option].name} {...getTagProps({ index })} />
                //     ))
                // }
                MenuProps={MenuProps}
            >
                {/*<Box style={{ paddingLeft: '0.5rem', paddingRight: '0.5'}}>*/}
                {/*    <TextField label="Filter" variant="standard" fullWidth={true} />*/}
                {/*</Box>*/}
                {selectOptions.map((option, index) => (
                    <MenuItem key={option.id} value={index}>
                        <Checkbox checked={selected.indexOf(index) > -1} />
                        <ListItemText primary={option.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>

    </>);
}